import axios from 'axios'
import { BUSCAR_HISTORICOS_RESERVAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

export default function buscarHistoricosReservas(idPedido, idEmpresa) {
  const url = `${URL}/reserva/pedido/${idPedido}/empresa/${idEmpresa}/historicos`
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({ type: BUSCAR_HISTORICOS_RESERVAS, payload: response })
  )
}
